module.exports = __webpack_public_path__ + "img/t4-i7.a58f8bf7.jpg";